<template>
  <div class="projects">
    <v-container class="my-1">
      <v-card>
        <v-card-title class="page-head">
          <div class="ph-left">
            <div class="ph-icon"><v-icon color="#1565c0">mdi-human-child</v-icon></div>
            <div>
              <div class="ph-title">Child Registration</div>
              <div class="ph-sub">Register and manage children</div>
            </div>
          </div>
          <v-spacer />
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            placeholder="Search..."
            outlined
            dense
            hide-details
            class="ph-search"
          />
          <v-btn class="ph-btn" @click="formNuevo()">
            <v-icon left small>mdi-plus</v-icon>
            New Child
          </v-btn>
        </v-card-title>

        <v-data-table
          class="elevation-0"
          :search="search"
          :headers="headers"
          :items="childs"
          item-value="id"
          :items-per-page="-1"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, -1], 'items-per-page-text': 'Rows per page' }"
        >
          <template v-slot:item.index="{ index }">
            <span class="cell-muted">{{ index + 1 }}</span>
          </template>

          <template v-slot:item.childimage="{ item }">
            <v-avatar size="38" class="avatar-ring">
              <v-img v-if="item.childimage" :src="uploadBaseUrl + item.childimage" />
              <v-icon v-else color="#90a4ae">mdi-human-child</v-icon>
            </v-avatar>
          </template>

          <template v-slot:item.childname="{ item }">
            <span class="cell-name">{{ item.childname }}</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="#2e7d32" v-bind="attrs" v-on="on" @click="formEditar(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit child</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="#c62828" v-bind="attrs" v-on="on" @click="borrar(item.id)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Delete child</span>
            </v-tooltip>
          </template>

          <template v-slot:item.more="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="#1565c0" v-bind="attrs" v-on="on" @click="show(item.id)">
                  <v-icon small>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>View details</span>
            </v-tooltip>
          </template>

          <template v-slot:no-data>
            <div class="empty-state">
              <v-icon size="44" color="#b0bec5">mdi-human-child</v-icon>
              <div class="empty-text">No children found</div>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="diag" scrollable max-width="420px">
        <v-card v-for="more in moreinfo" :key="more.id">
          <div class="dlg-head">
            <div class="dlg-head-icon"><v-icon color="#fff">mdi-human-child</v-icon></div>
            <div>
              <div class="dlg-title">Child Details</div>
              <div class="dlg-sub">{{ more.childname }}</div>
            </div>
            <v-spacer />
            <v-btn icon small class="dlg-close" @click="diag = false"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <div class="d-flex justify-center pt-5 pb-2">
            <v-avatar size="88" class="avatar-ring lg">
              <v-img v-if="more.childimage" :src="uploadBaseUrl + more.childimage" />
              <v-icon v-else size="40" color="#90a4ae">mdi-human-child</v-icon>
            </v-avatar>
          </div>
          <v-card-text style="height: 300px;">
            <v-simple-table>
              <tbody>
                <tr><th>Name</th><td>{{ more.childname }}</td></tr>
                <tr><th>Date of Birth</th><td>{{ more.dateofbirth }}</td></tr>
                <tr><th>Age</th><td>{{ more.age }}</td></tr>
                <tr><th>Sex</th><td>{{ more.sex }}</td></tr>
                <tr><th>Where Found</th><td>{{ more.wherethechildfound }}</td></tr>
                <tr><th>Case Description</th><td>{{ more.casedescription }}</td></tr>
                <tr><th>Health Status</th><td>{{ more.healthstatus }}</td></tr>
                <tr><th>Found Date</th><td>{{ more.founddate }}</td></tr>
                <tr><th>Reg Date</th><td>{{ more.regdate }}</td></tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <div class="dlg-head">
            <div class="dlg-head-icon">
              <v-icon color="#fff">{{ oper === 'Add' ? 'mdi-account-plus' : 'mdi-account-edit' }}</v-icon>
            </div>
            <div>
              <div class="dlg-title">{{ oper === 'Add' ? 'New Child' : 'Edit Child' }}</div>
              <div class="dlg-sub">{{ oper === 'Add' ? 'Register a new child' : 'Update child details' }}</div>
            </div>
            <v-spacer />
            <v-btn icon small class="dlg-close" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <v-card-text class="pt-5">
            <v-form>
              <input type="hidden" v-model="child.id" />

              <div class="photo-row">
                <v-avatar size="64" class="avatar-ring lg">
                  <v-img v-if="child.childimage" :src="uploadBaseUrl + child.childimage" />
                  <v-icon v-else size="30" color="#90a4ae">mdi-human-child</v-icon>
                </v-avatar>
                <v-file-input
                  accept="image/*"
                  label="Photo"
                  prepend-icon="mdi-camera"
                  outlined
                  dense
                  hide-details
                  show-size
                  class="photo-input"
                  @change="onFilechange"
                />
                <input type="hidden" v-model="child.childimage" />
              </div>

              <div class="form-section">Child Details</div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field v-model="child.childname" label="Child Name" outlined dense prepend-inner-icon="mdi-account-outline" required />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select v-model="child.sex" :items="['Male', 'Female']" label="Sex" outlined dense prepend-inner-icon="mdi-gender-male-female" required />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="child.dateofbirth" label="Date of Birth" type="date" outlined dense prepend-inner-icon="mdi-calendar" @change="calculateAge" required />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="child.age" label="Age" outlined dense prepend-inner-icon="mdi-counter" disabled />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="child.clan" label="Clan" outlined dense prepend-inner-icon="mdi-account-group-outline" required />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select v-model="child.status" :items="['Active', 'Died']" label="Status" outlined dense prepend-inner-icon="mdi-heart-pulse" required />
                </v-col>
                <v-col cols="12" md="6" v-if="isAdmin">
                  <v-select
                    v-model="child.district"
                    :items="districts"
                    item-text="district_name"
                    item-value="district_name"
                    label="District"
                    outlined
                    dense
                    prepend-inner-icon="mdi-map-marker-outline"
                  />
                </v-col>
              </v-row>

              <div class="form-section">Parent / Guardian</div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field v-model="child.parentname" label="Parent Name" outlined dense prepend-inner-icon="mdi-account-outline" required />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="child.parentcontact" label="Parent Contact" outlined dense prepend-inner-icon="mdi-phone-outline" required />
                </v-col>
              </v-row>

              <div class="form-section">Case Information</div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field v-model="child.wherethechildfound" label="Where the child was found" outlined dense prepend-inner-icon="mdi-map-marker-outline" required />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="child.founddate" label="Found Date" type="date" outlined dense prepend-inner-icon="mdi-calendar" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="child.healthstatus" label="Health Status" outlined dense prepend-inner-icon="mdi-medical-bag" />
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="child.casedescription" label="Case Description" rows="3" outlined dense prepend-inner-icon="mdi-text-box-outline" />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="dlg-actions">
            <v-spacer />
            <v-btn text @click="dialog = false">Cancel</v-btn>
            <v-btn color="#0d2d63" dark @click="guardar()">
              <v-icon left small>mdi-content-save-outline</v-icon>
              {{ oper === 'Add' ? 'Save Child' : 'Save Changes' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" bottom right :multi-line="multiLine" color="blue">
        {{ text }}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;
const UPLOAD_URL = process.env.VUE_APP_UPLOAD_URL;
const IMAGE_BASE = process.env.VUE_APP_IMAGE_BASE;

export default {
  name: 'ChildVue',
  data() {
    return {
      search: '',
      childs: [],
      dialog: false,
      diag: false,
      oper: 'Add',
      operacion: '',
      snackbar: false,
      multiLine: true,
      text: '',
      moreinfo: [],
      child: {
        id: null,
        childname: '',
        dateofbirth: '',
        age: '',
        childimage: '',
        sex: '',
        parentname: 'N/A',
        parentcontact: 'N/A',
        clan: 'N/A',
        wherethechildfound: '',
        casedescription: '',
        healthstatus: '',
        founddate: '',
        status: '',
        district: '',
      },
      districts: [],
      headers: [
        { text: 'ID', value: 'index' },
        { text: 'Image', value: 'childimage' },
        { text: 'Name', value: 'childname' },
        { text: 'Age', value: 'age' },
        { text: 'Show more', value: 'more', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      uploadBaseUrl: IMAGE_BASE,
      authenticated: JSON.parse(localStorage.getItem('status')),
    };
  },

  computed: {
    isAdmin() {
      try {
        const u = JSON.parse(localStorage.getItem('user') || '{}');
        const r = (u.role || localStorage.getItem('usertype') || '').toString().trim().toLowerCase();
        return r === 'admin';
      } catch (e) {
        return false;
      }
    },
  },

  mounted() {
    if (!this.authenticated) this.$router.replace({ name: 'login' });
    this.mostrar();
    this.fetchDistricts();
  },

  methods: {
    calculateAge() {
      if (!this.child.dateofbirth) return (this.child.age = '');
      const today = new Date();
      const dob = new Date(this.child.dateofbirth);
      let age = today.getFullYear() - dob.getFullYear();
      const m = today.getMonth() - dob.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
      this.child.age = age;
    },

    onFilechange(file) {
      if (!file) return;
      const formData = new FormData();
      formData.append('file', file);
      axios
        .post(UPLOAD_URL, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((res) => {
          this.child.childimage = res.data;
          this.snackbar = true;
          this.text = res.data ? 'Image uploaded!' : 'Upload failed.';
          setTimeout(() => (this.snackbar = false), 2000);
        })
        .catch(() => {
          this.snackbar = true;
          this.text = 'Upload error';
          setTimeout(() => (this.snackbar = false), 2000);
        });
    },

    getChildImage(name) {
      if (!name) return null;
      return `${this.uploadBaseUrl}${name}`;
    },

    formNuevo() {
      this.dialog = true;
      this.operacion = 'crear';
      this.oper = 'Add';
      this.child = {
        id: null,
        childname: '',
        dateofbirth: '',
        age: '',
        childimage: '',
        sex: '',
        parentname: 'N/A',
        parentcontact: 'N/A',
        clan: 'N/A',
        wherethechildfound: '',
        casedescription: '',
        healthstatus: '',
        founddate: '',
        status: '',
        district: '',
      };
    },

    formEditar(item) {
      this.dialog = true;
      this.operacion = 'editar';
      this.oper = 'Update';
      this.child = { ...item };
    },

    async guardar() {
      const ok = this.operacion === 'crear' ? await this.crear() : await this.editar();
      if (ok) this.dialog = false;
    },

    backendErrorText(res) {
      if (res && Array.isArray(res.data) && res.data[0] && res.data[0].ok === false) {
        return res.data[0].msg || 'Save failed';
      }
      return '';
    },

    showSnackbar(text) {
      this.text = text;
      this.snackbar = true;
      setTimeout(() => (this.snackbar = false), 3000);
    },

    async crear() {
      const p = {
        opcion: 10,
        op: 1,
        magac: this.child.childname,
        dhalasho: this.child.dateofbirth,
        da: this.child.age,
        sawir: this.child.childimage || 'logo.png',
        jinsi: this.child.sex,
        parentname: this.child.parentname,
        parentcontact: this.child.parentcontact,
        clan: this.child.clan,
        wfound: this.child.wherethechildfound,
        cdesc: this.child.casedescription,
        hstatus: this.child.healthstatus,
        fdate: this.child.founddate,
        st: this.child.status,
        district: this.child.district,
        usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '',
      };
      try {
        const res = await axios.post(API_URL, p);
        const err = this.backendErrorText(res);
        if (err) {
          this.showSnackbar(err);
          return false;
        }
        this.mostrar();
        this.showSnackbar('Inserted successfully');
        return true;
      } catch (e) {
        this.showSnackbar('Network error. Please try again.');
        return false;
      }
    },

    async editar() {
      const p = {
        opcion: 10,
        op: 11,
        idga: this.child.id,
        magac: this.child.childname,
        dhalasho: this.child.dateofbirth,
        da: this.child.age,
        sawir: this.child.childimage,
        jinsi: this.child.sex,
        parentname: this.child.parentname,
        parentcontact: this.child.parentcontact,
        clan: this.child.clan,
        wfound: this.child.wherethechildfound,
        cdesc: this.child.casedescription,
        hstatus: this.child.healthstatus,
        fdate: this.child.founddate,
        st: this.child.status,
        district: this.child.district,
        usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '',
      };
      try {
        const res = await axios.post(API_URL, p);
        const err = this.backendErrorText(res);
        if (err) {
          this.showSnackbar(err);
          return false;
        }
        this.mostrar();
        this.showSnackbar('Updated successfully');
        return true;
      } catch (e) {
        this.showSnackbar('Network error. Please try again.');
        return false;
      }
    },

    borrar(id) {
      axios.post(API_URL, { opcion: 10, op: 12, idga: id, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' }).then(() => {
        this.mostrar();
        this.text = 'Deleted successfully';
        this.snackbar = true;
        setTimeout(() => (this.snackbar = false), 2000);
      });
    },

    show(id) {
      axios.post(API_URL, { opcion: 10, idga: id, op: 23, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' }).then((res) => {
        this.moreinfo = res.data || [];
        this.diag = true;
      });
    },

    mostrar() {
      axios.post(API_URL, { opcion: 10, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' }).then((res) => {
        this.childs = res.data || [];
      });
    },

    fetchDistricts() {
      axios.post(API_URL, { opcion: 40 }).then((res) => {
        this.districts = res.data || [];
      }).catch(() => { this.districts = []; });
    },
  },
};
</script>

<style>
tbody td,
tbody th {
  border-left: 1px solid silver;
}
</style>
